import { emailPattern, phonePattern, postalCodePattern } from "../../appconfig/Settings";

// Helper functions for validation
const isNullOrEmpty = (value: any): boolean => {
  return value === null || value === undefined || value === "";
};

const isNullOrBlank = (value: any): boolean => {
  return isNullOrEmpty(value) || (typeof value === "string" && value.trim() === "");
};

// Initialize window functions if they don't exist
if (typeof window.cn === "undefined") {
  window.cn = isNullOrEmpty;
}

if (typeof window.cb === "undefined") {
  window.cb = (value: any) => !isNullOrBlank(value);
}

// ..................................................................................................................

export const validateCurrentSection = (activeSection: string, userData: any) => {
  const sectionErrors: any = {};
  let isError = false;

  switch (activeSection) {
    case "identification":
      if (window.cn(userData.filed_with_nagra_before) && !window.cb(userData.filed_with_nagra_before)) {
        sectionErrors.filed_with_nagra_before = "Please select if you have filed with us before *";
        isError = true;
      } else if (userData.filed_with_nagra_before === "1") {
        // User selected "Yes" but hasn't successfully searched
        let searchError = false;
        if (window.cn(userData.returningSIN)) {
          sectionErrors.returningSIN = "SIN Number is required *";
          searchError = true;
          isError = true;
        }
        if (window.cn(userData.returningEmail)) {
          sectionErrors.returningEmail = "Email Address is required *";
          searchError = true;
          isError = true;
        }

        if (!searchError) {
          sectionErrors.filed_with_nagra_before = "Please find your information to proceed, or select 'No' to continue as a new client.";
          isError = true;
        }
      }
      break;
    case "personal":
      // Name validation

      if (window.cn(userData.last_name) && !window.cb(userData.last_name)) {
        sectionErrors.last_name = "Enter Last Name *";
        isError = true;
      }

      // Email validation
      if (window.cn(userData.email) && !window.cb(userData.email)) {
        sectionErrors.email = "Enter Email *";
        isError = true;
      } else if (userData.email && !emailPattern.test(userData.email)) {
        sectionErrors.email = "Enter Valid Email *";
        isError = true;
      }

      // Phone validation
      if (window.cn(userData.phone) && !window.cb(userData.phone)) {
        sectionErrors.phone = "Enter Phone *";
        isError = true;
      } else if (userData.phone && !phonePattern.test(userData.phone)) {
        sectionErrors.phone = "Enter Valid Phone *";
        isError = true;
      }

      // sin no validation
      if (window.cn(userData.sin_number) && !window.cb(userData.sin_number)) {
        sectionErrors.sin_number = "Enter SIN Number *";
        isError = true;
      } else if (userData.sin_number && !/^\d{9}$/.test(userData.sin_number)) {
        sectionErrors.sin_number = "SIN Number must be exactly 9 digits";
        isError = true;
      }

      // Date of Birth validation
      if (window.cn(userData.date_of_birth) && !window.cb(userData.date_of_birth)) {
        sectionErrors.date_of_birth = "Enter Date of Birth *";
        isError = true;
      }

      // Street Address validation
      if (window.cn(userData.street_address) && !window.cb(userData.street_address)) {
        sectionErrors.street_address = "Enter Street Address *";
        isError = true;
      }

      // City validation
      if (window.cn(userData.city) && !window.cb(userData.city)) {
        sectionErrors.city = "Enter City *";
        isError = true;
      }

      // Province validation
      if (window.cn(userData.province) && !window.cb(userData.province)) {
        sectionErrors.province = "Select Province *";
        isError = true;
      }

      // Postal Code validation
      if (window.cn(userData.postal_code) && !window.cb(userData.postal_code)) {
        sectionErrors.postal_code = "Enter Postal Code *";
        isError = true;
      } else if (userData.postal_code && !postalCodePattern.test(userData.postal_code)) {
        sectionErrors.postal_code = "Enter Valid Postal Code *";
        isError = true;
      }

      // Marital status - validation for Dec 31 status
      if (window.cn(userData.dec_marrige_status) && !window.cb(userData.dec_marrige_status)) {
        sectionErrors.dec_marrige_status = "Please select any one of above *";
        isError = true;
      }

      if (
        userData?.dec_marrige_status == "Married" ||
        userData?.dec_marrige_status == "Living common-law" ||
        userData?.dec_marrige_status == "Divorced" ||
        userData?.dec_marrige_status == "Separated"
      ) {
        if (window.cn(userData.marrige_status_changed_date) && !window.cb(userData.marrige_status_changed_date)) {
          sectionErrors.marrige_status_changed_date = "Please select marital status changed date *";
          isError = true;
        }
      }

      if (userData?.dec_marrige_status === "Married" || userData?.dec_marrige_status === "Living common-law") {
        if (window.cn(userData.is_spouse_canadian_resident) && !window.cb(userData.is_spouse_canadian_resident)) {
          sectionErrors.is_spouse_canadian_resident = "Please select spouse canadian resident or not *";
          isError = true;
        }
      }

      if (String(userData.is_spouse_canadian_resident) === "1") {
        // spouse SIN
        if (window.cn(userData.spouse_sin_number) && !window.cb(userData.spouse_sin_number)) {
          sectionErrors.spouse_sin_number = "Enter Spouse SIN Number *";
          isError = true;
        } else if (userData.spouse_sin_number && !/^\d{9}$/.test(userData.spouse_sin_number)) {
          sectionErrors.spouse_sin_number = "Spouse SIN Number must be exactly 9 digits";
          isError = true;
        }
      }

      // validate field only if married and spouse canadian resident
      if (
        (userData?.dec_marrige_status === "Married" || userData.dec_marrige_status === "Living common-law") &&
        userData?.is_spouse_canadian_resident === "1"
      ) {
        // spouse last name
        if (window.cn(userData.spouse_last_name) && !window.cb(userData.spouse_last_name)) {
          sectionErrors.spouse_last_name = "Enter Spouse Last Name *";
          isError = true;
        }

        // Spouse personal details
        if (window.cn(userData.spouse_dob) && !window.cb(userData.spouse_dob)) {
          sectionErrors.spouse_dob = "Enter Spouse Date of Birth *";
          isError = true;
        }

        if (window.cn(userData.spouse_email) && !window.cb(userData.spouse_email)) {
          sectionErrors.spouse_email = "Enter Spouse Email *";
          isError = true;
        } else if (userData.spouse_email && !emailPattern.test(userData.spouse_email)) {
          sectionErrors.spouse_email = "Enter Valid Spouse Email *";
          isError = true;
        }

        // if (
        //   window.cn(userData.spouse_phone) &&
        //   !window.cb(userData.spouse_phone)
        // ) {
        //   sectionErrors.spouse_phone = "Enter Spouse Phone *";
        //   isError = true;
        // } else if (
        //   userData.spouse_phone &&
        //   !phonePattern.test(userData.spouse_phone)
        // ) {
        //   sectionErrors.spouse_phone = "Enter Valid Spouse Phone *";
        //   isError = true;
        // }
      }

      // validate fields only id married and not canadian resident
      if (
        (userData?.dec_marrige_status === "Married" || userData.dec_marrige_status === "Living common-law") &&
        userData?.is_spouse_canadian_resident === "0"
      ) {
        // spouse last name
        if (window.cn(userData.spouse_last_name) && !window.cb(userData.spouse_last_name)) {
          sectionErrors.spouse_last_name = "Enter Spouse Last Name *";
          isError = true;
        }

        // Spouse personal details
        if (window.cn(userData.spouse_dob) && !window.cb(userData.spouse_dob)) {
          sectionErrors.spouse_dob = "Enter Spouse Date of Birth *";
          isError = true;
        }

        // spouse income from home country
        if (window.cn(userData.spouse_income_from_home) && !window.cb(userData.spouse_income_from_home)) {
          sectionErrors.spouse_income_from_home = "Enter Spouse Income *";
          isError = true;
        } else if (userData.spouse_income_from_home && /[^0-9.]/.test(userData.spouse_income_from_home)) {
          sectionErrors.spouse_income_from_home = "Enter valid spouse income *";
          isError = true;
        }
      }

      break;

    case "employment":
      // First time form filling status
      if (window.cn(userData.first_time_form_filling_status) && !window.cb(userData.first_time_form_filling_status)) {
        sectionErrors.first_time_form_filling_status = "Please select Form Status *";
        isError = true;
      }

      // moved from province status
      if (userData?.first_time_form_filling_status === "0") {
        if (window.cn(userData.moved_from_province) && !window.cb(userData.moved_from_province)) {
          sectionErrors.moved_from_province = "Please select moved or not *";
          isError = true;
        }
      }

      // SIN Number validation (conditional)
      if (userData.first_time_form_filling_status === "1") {
        // Income from home validation
        if (window.cn(userData.income_from_home) && !window.cb(userData.income_from_home)) {
          sectionErrors.income_from_home = "Enter Income *";
          isError = true;
        } else if (userData.income_from_home && /[^0-9.]/.test(userData.income_from_home)) {
          sectionErrors.income_from_home = "Enter valid income *";
          isError = true;
        }

        // Date of entry validation
        if (window.cn(userData.date_of_entry) && !window.cb(userData.date_of_entry)) {
          sectionErrors.date_of_entry = "Enter Date of Entry *";
          isError = true;
        }
      }

      // province validation according to status

      if (userData?.first_time_form_filling_status === "0" && userData?.moved_from_province === "1") {
        // Moving date validation
        if (window.cn(userData.moving_date) && !window.cb(userData.moving_date)) {
          sectionErrors.moving_date = "Enter Moving Date *";
          isError = true;
        }

        // Province from validation
        if (window.cn(userData.province_from) && !window.cb(userData.province_from)) {
          sectionErrors.province_from = "Select Province From *";
          isError = true;
        }

        // Province to validation
        if (window.cn(userData.province_to) && !window.cb(userData.province_to)) {
          sectionErrors.province_to = "Select Province To *";
          isError = true;
        } else if (userData.province_to && userData.province_from && userData.province_to === userData.province_from) {
          sectionErrors.province_to = "Select Province To different From Province From *";
          isError = true;
        }
      }

      // Benefit status validation
      if (userData.province == "British Columbia" || userData.province == "Manitoba") {
        if (window.cn(userData.benefit_status) && !window.cb(userData.benefit_status)) {
          sectionErrors.benefit_status = "Please select if you want to apply for Rent Benefit *";
          isError = true;
        }
      }

      // Rent benefit related validations
      // if (userData.benefit_status === "1") {
      //   // Landlords validation
      //   const landlords = userData.landlords?.length ? userData.landlords : [{ name: "", amount: "", months: "" }];

      //   const landlordErrors: any[] = [];

      //   landlords.forEach((landlord: any, index: number) => {
      //     const errors: any = {};

      //     // Validate name
      //     if (window.cn(landlord.name) && !window.cb(landlord.name)) {
      //       errors.name = `Landlord name ${index + 1} is required`;
      //       isError = true;
      //     }

      //     // Validate amount
      //     if (window.cn(landlord.amount) && !window.cb(landlord.amount)) {
      //       errors.amount = `Amount for landlord ${index + 1} is required`;
      //       isError = true;
      //     } else if (landlord.amount <= 0) {
      //       errors.amount = `Amount for landlord ${index + 1} must be greater than 0`;
      //       isError = true;
      //     }

      //     // Validate amount
      //     if (window.cn(landlord.months) && !window.cb(landlord.months)) {
      //       errors.months = `months for landlord ${index + 1} is required`;
      //       isError = true;
      //     } else if (landlord.months <= 0) {
      //       errors.months = `months for landlord ${index + 1} must be greater than 0`;
      //       isError = true;
      //     }

      //     landlordErrors[index] = errors;
      //   });

      //   // Attach to section errors only if there’s any validation issue
      //   if (landlordErrors.some((e) => Object.keys(e).length > 0)) {
      //     sectionErrors.landlords = landlordErrors;
      //   }
      // }

      if (userData.benefit_status === "1") {
        // Landlords validation
        const landlords = userData.landlords?.length ? userData.landlords : [{ name: "", amount: 0, months: "" }];

        const landlordErrors: any[] = [];

        landlords.forEach((landlord: any, index: number) => {
          const errors: any = {};

          // Validate name
          if (window.cn(landlord.name) && !window.cb(landlord.name)) {
            errors.name = `Landlord name ${index + 1} is required`;
            isError = true;
          }

          // Validate amount
          if (landlord.amount === null || landlord.amount === undefined || landlord.amount === "") {
            errors.amount = `Amount for landlord ${index + 1} is required`;
            isError = true;
          }

          // else if (Number(landlord.amount) <= 0) {
          //   errors.amount = `Amount for landlord ${index + 1} must be greater than 0`;
          //   isError = true;
          // }

          // Validate months
          if (landlord.months === null || landlord.months === undefined || landlord.months === "") {
            errors.months = `Months for landlord ${index + 1} is required`;
            isError = true;
          }

          // else if (Number(landlord.months) <= 0) {
          //   errors.months = `Months for landlord ${index + 1} must be greater than 0`;
          //   isError = true;
          // }

          landlordErrors[index] = errors;
        });

        // Attach to section errors only if there's any validation issue
        if (landlordErrors.some((e) => Object.keys(e).length > 0)) {
          sectionErrors.landlords = landlordErrors;
        }
      }

      if (String(userData.is_spouse_canadian_resident) === "1") {
        // spouse SIN
        // if (window.cn(userData.spouse_sin_number) && !window.cb(userData.spouse_sin_number)) {
        //   sectionErrors.spouse_sin_number = "Enter Spouse SIN Number *";
        //   isError = true;
        // } else if (userData.spouse_sin_number && !/^\d{9}$/.test(userData.spouse_sin_number)) {
        //   sectionErrors.spouse_sin_number = "Spouse SIN Number must be exactly 9 digits";
        //   isError = true;
        // }

        // spouse filling form status
        if (window.cn(userData.spouse_first_time_form_filling_status) && !window.cb(userData.spouse_first_time_form_filling_status)) {
          sectionErrors.spouse_first_time_form_filling_status = "Please select spouse filling form for first time or not *";
          isError = true;
        }
      }

      // if spouse filling for first time then validate date of entry and income from home country
      if (userData?.spouse_first_time_form_filling_status === "1") {
        if (window.cn(userData.spouse_date_of_entry) && !window.cb(userData.spouse_date_of_entry)) {
          sectionErrors.spouse_date_of_entry = "Enter Spouse Date of Entry *";
          isError = true;
        }

        // income from home country
        if (window.cn(userData.spouse_income_from_home) && !window.cb(userData.spouse_income_from_home)) {
          sectionErrors.spouse_income_from_home = "Enter Spouse Income *";
          isError = true;
        } else if (userData.spouse_income_from_home && /[^0-9.]/.test(userData.spouse_income_from_home)) {
          sectionErrors.spouse_income_from_home = "Enter valid spouse income *";
          isError = true;
        }
      }

      // spouse not filling for first time
      if (userData?.spouse_first_time_form_filling_status === "0") {
        if (window.cn(userData.spouse_moved_from_province) && !window.cb(userData.spouse_moved_from_province)) {
          sectionErrors.spouse_moved_from_province = "Please select spouse moved or not *";
          isError = true;
        }
      }

      if (userData?.spouse_first_time_form_filling_status === "0" && userData?.spouse_moved_from_province === "1") {
        // Spouse immigration details
        if (window.cn(userData.spouse_moving_date) && !window.cb(userData.spouse_moving_date)) {
          sectionErrors.spouse_moving_date = "Enter Spouse Moving Date *";
          isError = true;
        }

        // Spouse province selections
        if (window.cn(userData.spouse_province_from) && !window.cb(userData.spouse_province_from)) {
          sectionErrors.spouse_province_from = "Select Spouse Province From *";
          isError = true;
        }

        if (window.cn(userData.spouse_province_to) && !window.cb(userData.spouse_province_to)) {
          sectionErrors.spouse_province_to = "Select Province To *";
          isError = true;
        } else if (userData.spouse_province_to && userData.spouse_province_from && userData.spouse_province_to == userData.spouse_province_from) {
          sectionErrors.spouse_province_to = "Select Province To different From Province From *";
          isError = true;
        }
      }

      // status in canada
      if (window.cn(userData.canadian_status) && !window.cb(userData.canadian_status)) {
        sectionErrors.canadian_status = "Select Status *";
        isError = true;
      }

      // spouse status in canada
      if (
        (userData?.dec_marrige_status === "Married" || userData?.dec_marrige_status === "Living common-law") &&
        userData?.is_spouse_canadian_resident == "1"
      ) {
        if (window.cn(userData.spouse_canadian_status) && !window.cb(userData.spouse_canadian_status)) {
          sectionErrors.spouse_canadian_status = "Select Status *";
          isError = true;
        }
      }

      break;

    case "general_questions":
      // first_time_home_buyer
      if (window.cn(userData.first_time_home_buyer) && !window.cb(userData.first_time_home_buyer)) {
        sectionErrors.first_time_home_buyer = "Required *";
        isError = true;
      }

      // property_sell
      if (window.cn(userData.property_sell) && !window.cb(userData.property_sell)) {
        sectionErrors.property_sell = "Required *";
        isError = true;
      }

      // property_more_than_1_lakh
      if (window.cn(userData.property_more_than_1_lakh) && !window.cb(userData.property_more_than_1_lakh)) {
        sectionErrors.property_more_than_1_lakh = "Required *";
        isError = true;
      }
      // northern_resident_benefit
      if (window.cn(userData.northern_resident_benefit) && !window.cb(userData.northern_resident_benefit)) {
        sectionErrors.northern_resident_benefit = "Required *";
        isError = true;
      }

      // rental_income
      if (window.cn(userData.rental_income) && !window.cb(userData.rental_income)) {
        sectionErrors.rental_income = "Required *";
        isError = true;
      }

      // self employed income
      if (window.cn(userData.self_employed_income) && !window.cb(userData.self_employed_income)) {
        sectionErrors.self_employed_income = "Required *";
        isError = true;
      }

      if (userData?.self_employed_income == "1") {
        if (window.cn(userData.has_gst) && !window.cb(userData.has_gst)) {
          sectionErrors.has_gst = "Required *";
          isError = true;
        }

        if (window.cn(userData.self_employed_amount) && !window.cb(userData.self_employed_amount)) {
          sectionErrors.self_employed_amount = "Enter self employed amount*";
          isError = true;
        }
      }

      if (userData?.has_gst == "1") {
        if (window.cn(userData.gst_no) && !window.cb(userData.gst_no)) {
          sectionErrors.gst_no = "Required *";
          isError = true;
        }
      }

      // spouse self employed expenses

      if (userData?.is_spouse_canadian_resident == "1") {
        if (window.cn(userData.spouse_self_employed_income) && !window.cb(userData.spouse_self_employed_income)) {
          sectionErrors.spouse_self_employed_income = "Required *";
          isError = true;
        }

        if (userData?.spouse_self_employed_income == "1") {
          if (window.cn(userData.spouse_has_gst) && !window.cb(userData.spouse_has_gst)) {
            sectionErrors.spouse_has_gst = "Required *";
            isError = true;
          }

          if (window.cn(userData.spouse_self_employed_amount) && !window.cb(userData.spouse_self_employed_amount)) {
            sectionErrors.spouse_self_employed_amount = "Enter spouse self employed amount*";
            isError = true;
          }
        }

        if (userData?.spouse_has_gst == "1") {
          if (window.cn(userData.spouse_gst_no) && !window.cb(userData.spouse_gst_no)) {
            sectionErrors.spouse_gst_no = "Required *";
            isError = true;
          }
        }
      }

      if (window.cn(userData.long_haul_truck_driver) && !window.cb(userData.long_haul_truck_driver)) {
        sectionErrors.long_haul_truck_driver = "Required *";
        isError = true;
      }

      // wfh employed
      if (window.cn(userData.work_from_home) && !window.cb(userData.work_from_home)) {
        sectionErrors.work_from_home = "Required *";
        isError = true;
      }

      if (userData?.work_from_home == "1") {
        if (window.cn(userData.claim_expense) && !window.cb(userData.claim_expense)) {
          sectionErrors.claim_expense = "Required *";
          isError = true;
        }
      }

      // spouse wfh expenses
      if (userData?.is_spouse_canadian_resident == "1") {
        if (window.cn(userData.spouse_work_from_home) && !window.cb(userData.spouse_work_from_home)) {
          sectionErrors.spouse_work_from_home = "Required *";
          isError = true;
        }

        if (userData?.spouse_work_from_home == "1") {
          if (window.cn(userData.spouse_claim_expense) && !window.cb(userData.spouse_claim_expense)) {
            sectionErrors.spouse_claim_expense = "Required *";
            isError = true;
          }
        }
      }

      // if (userData?.rental_income == "1") {
      //   const generalOtherExpenses = userData.generalOtherExpenses?.length ? userData.generalOtherExpenses : [{ name: "", amount: 0 }];

      //   const otherExpensesErrors: any[] = [];

      //   generalOtherExpenses.forEach((expense: any, index: number) => {
      //     const errors: any = {};

      //     // Validate name
      //     if (window.cn(expense.name) && !window.cb(expense.name)) {
      //       errors.name = `Expense name ${index + 1} is required`;
      //       isError = true;
      //     }

      //     // Validate amount
      //     if (expense.amount === null || expense.amount === undefined || expense.amount === "") {
      //       errors.amount = `Amount for expense ${index + 1} is required`;
      //       isError = true;
      //     }

      //     // else if (Number(expense.amount) <= 0) {
      //     //   errors.amount = `Amount for expense ${index + 1} must be greater than 0`;
      //     //   isError = true;
      //     // }

      //     otherExpensesErrors[index] = errors;
      //   });

      //   // Attach to section errors only if there's any validation issue
      //   if (otherExpensesErrors.some((e) => Object.keys(e).length > 0)) {
      //     sectionErrors.generalOtherExpenses = otherExpensesErrors;
      //   }
      // }

      break;

    case "marital":
      // Spouse Canadian resident validation (if married)
      if (userData.dec_marrige_status === "Married" || userData?.dec_marrige_status === "Living common-law") {
        if (window.cn(userData.is_spouse_canadian_resident) && !window.cb(userData.is_spouse_canadian_resident)) {
          sectionErrors.is_spouse_canadian_resident = "Please select residential Status *";
          isError = true;
        }

        // Additional validations based on spouse residency
        if (userData.is_spouse_canadian_resident === "1") {
          // Spouse first name validation
          if (window.cn(userData.spouse_first_name) && !window.cb(userData.spouse_first_name)) {
            sectionErrors.spouse_first_name = "Enter Spouse First Name *";
            isError = true;
          }

          // spouse last name
          if (window.cn(userData.spouse_last_name) && !window.cb(userData.spouse_last_name)) {
            sectionErrors.spouse_last_name = "Enter Spouse Last Name *";
            isError = true;
          }

          // Spouse personal details
          if (window.cn(userData.spouse_dob) && !window.cb(userData.spouse_dob)) {
            sectionErrors.spouse_dob = "Enter Spouse Date of Birth *";
            isError = true;
          }

          if (window.cn(userData.spouse_email) && !window.cb(userData.spouse_email)) {
            sectionErrors.spouse_email = "Enter Spouse Email *";
            isError = true;
          } else if (userData.spouse_email && !emailPattern.test(userData.spouse_email)) {
            sectionErrors.spouse_email = "Enter Valid Spouse Email *";
            isError = true;
          }

          if (window.cn(userData.spouse_phone) && !window.cb(userData.spouse_phone)) {
            sectionErrors.spouse_phone = "Enter Spouse Phone *";
            isError = true;
          } else if (userData.spouse_phone && !phonePattern.test(userData.spouse_phone)) {
            sectionErrors.spouse_phone = "Enter Valid Spouse Phone *";
            isError = true;
          }

          if (window.cn(userData.spouse_sin_number) && !window.cb(userData.spouse_sin_number)) {
            sectionErrors.spouse_sin_number = "Enter Spouse SIN Number *";
            isError = true;
          } else if (userData.spouse_sin_number && !/^\d{9}$/.test(userData.spouse_sin_number)) {
            sectionErrors.spouse_sin_number = "Spouse SIN Number must be exactly 9 digits";
            isError = true;
          }

          // spouse filling form for first time
          if (window.cn(userData.spouse_first_time_form_filling_status) && !window.cb(userData.spouse_first_time_form_filling_status)) {
            sectionErrors.spouse_first_time_form_filling_status = "Please select spouse filling form for first time or not *";
            isError = true;
          }

          // if spouse filling for first time then validate date of entry and income from home country
          if (userData?.spouse_first_time_form_filling_status === "1") {
            if (window.cn(userData.spouse_date_of_entry) && !window.cb(userData.spouse_date_of_entry)) {
              sectionErrors.spouse_date_of_entry = "Enter Spouse Date of Entry *";
              isError = true;
            }

            // income from home country
            // if (
            //   window.cn(userData.spouse_income_from_home) &&
            //   !window.cb(userData.spouse_income_from_home)
            // ) {
            //   sectionErrors.spouse_income_from_home = "Enter Spouse Income *";
            //   isError = true;
            // } else if (
            //   userData.spouse_income_from_home &&
            //   /[^0-9.]/.test(userData.spouse_income_from_home)
            // ) {
            //   sectionErrors.spouse_income_from_home =
            //     "Enter valid spouse income *";
            //   isError = true;
            // }
          }

          // spouse not filling for first time
          if (userData?.spouse_first_time_form_filling_status === "0") {
            if (window.cn(userData.spouse_moved_from_province) && !window.cb(userData.spouse_moved_from_province)) {
              sectionErrors.spouse_moved_from_province = "Please select spouse moved or not *";
              isError = true;
            }
          }

          if (userData?.spouse_first_time_form_filling_status === "0" && userData?.spouse_moved_from_province === "1") {
            // Spouse immigration details
            if (window.cn(userData.spouse_moving_date) && !window.cb(userData.spouse_moving_date)) {
              sectionErrors.spouse_moving_date = "Enter Spouse Moving Date *";
              isError = true;
            }

            // Spouse province selections
            if (window.cn(userData.spouse_province_from) && !window.cb(userData.spouse_province_from)) {
              sectionErrors.spouse_province_from = "Select Spouse Province From *";
              isError = true;
            }

            // if (
            //   window.cn(userData.spouse_province_to) &&
            //   !window.cb(userData.spouse_province_to)
            // ) {
            //   sectionErrors.spouse_province_to = "Select Spouse Province To *";
            //   isError = true;
            // }

            if (window.cn(userData.spouse_province_to) && !window.cb(userData.spouse_province_to)) {
              sectionErrors.spouse_province_to = "Select Spouse Province To *";
              isError = true;
            } else if (
              userData.spouse_province_to &&
              userData.spouse_province_from &&
              userData.spouse_province_to === userData.spouse_province_from
            ) {
              sectionErrors.spouse_province_to = "Select Province To different From Province From *";
              isError = true;
            }
          }

          // Spouse file uploads
          // if (
          //   window.cn(userData.spouse_t5008_file) &&
          //   !window.cb(userData.spouse_t5008_file)
          // ) {
          //   sectionErrors.spouse_t5008_file = "Upload Spouse T5008 File *";
          //   isError = true;
          // }

          // if (
          //   window.cn(userData.spouse_t2202a_file) &&
          //   !window.cb(userData.spouse_t2202a_file)
          // ) {
          //   sectionErrors.spouse_t2202a_file = "Upload Spouse T2202A File *";
          //   isError = true;
          // }

          // if (
          //   window.cn(userData.spouse_uber_file) &&
          //   !window.cb(userData.spouse_uber_file)
          // ) {
          //   sectionErrors.spouse_uber_file = "Upload Spouse Uber File *";
          //   isError = true;
          // }

          // if (
          //   window.cn(userData.spouse_t4_file) &&
          //   !window.cb(userData.spouse_t4_file)
          // ) {
          //   sectionErrors.spouse_t4_file = "Upload Spouse T4 files *";
          //   isError = true;
          // }

          // if (
          //   window.cn(userData.spouse_t5007_file) &&
          //   !window.cb(userData.spouse_t5007_file)
          // ) {
          //   sectionErrors.spouse_t5007_file = "Upload Spouse T5007 File *";
          //   isError = true;
          // }

          // if (
          //   window.cn(userData.spouse_t5_file) &&
          //   !window.cb(userData.spouse_t5_file)
          // ) {
          //   sectionErrors.spouse_t5_file = "Upload Spouse T5 File *";
          //   isError = true;
          // }
        } else if (userData.is_spouse_canadian_resident === "0") {
          if (window.cn(userData.spouse_first_name) && !window.cb(userData.spouse_first_name)) {
            sectionErrors.spouse_first_name = "Enter Spouse First Name *";
            isError = true;
          }

          if (window.cn(userData.spouse_last_name) && !window.cb(userData.spouse_last_name)) {
            sectionErrors.spouse_last_name = "Enter Spouse Last Name *";
            isError = true;
          }

          if (window.cn(userData.spouse_dob) && !window.cb(userData.spouse_dob)) {
            sectionErrors.spouse_dob = "Enter Spouse Date of Birth *";
            isError = true;
          }

          // if (
          //   window.cn(userData.spouse_income_from_home) &&
          //   !window.cb(userData.spouse_income_from_home)
          // ) {
          //   sectionErrors.spouse_income_from_home = "Enter Spouse Income *";
          //   isError = true;
          // } else if (
          //   userData.spouse_income_from_home &&
          //   /[^0-9.]/.test(userData.spouse_income_from_home)
          // ) {
          //   sectionErrors.spouse_income_from_home =
          //     "Enter valid spouse income *";
          //   isError = true;
          // }
        }
      }
      break;

    // case "tax_summary":
    //   if (!userData.has_agreed) {
    //     sectionErrors.has_agreed = "You must agree to the terms and conditions *";
    //     isError = true;
    //   }
    //   break;

    default:
      break;
  }

  return { sectionErrors, isValid: !isError };
};
